import { type FC } from 'react';

import { ContentOptions } from '@/components/AdvertisePayments/components/Options/Options.types';
import { CheckedIcon } from '@/components/ui/Icons/Icons';

import * as S from './Options.styles';

export type OptionsContentModalProps = {
  contentOptions: ContentOptions;
};

export const OptionsContentModal: FC<OptionsContentModalProps> = ({
  contentOptions
}) => {
  return (
    <S.OptionDetailsCard>
      <S.OptionDetailsContent>
        <S.OptionFeatureList>
          {contentOptions.map(option => (
            <S.OptionFeatureItem key={option.id}>
              <S.OptionFeatureIcon>
                <CheckedIcon />
              </S.OptionFeatureIcon>
              <S.OptionFeatureTextGroup>
                <S.OptionFeatureTitle>{option.title}</S.OptionFeatureTitle>
                <S.OptionFeatureSubtitle>
                  {option.description}
                </S.OptionFeatureSubtitle>
              </S.OptionFeatureTextGroup>
            </S.OptionFeatureItem>
          ))}
        </S.OptionFeatureList>
      </S.OptionDetailsContent>
    </S.OptionDetailsCard>
  );
};
